import { useMemo, useRef, useState } from 'react';
import { ReactSimpleComponentProps } from '@/custom-types';
import { AddPicturesFromIncidentFormModalContext, AddPicturesFromIncidentFormModalContextProps } from './AddPicturesFromIncidentFormModalContext';

export const AddPicturesFromIncidentFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const picturesRef = useRef<File[]>([])
  const [isOpen, setOpen] = useState(false)

  const actions = useMemo<Omit<AddPicturesFromIncidentFormModalContextProps, 'pictures' | 'isOpen'>>(() => ({
    closeModal: () => {
      setOpen(false)
      picturesRef.current = []
    },

    openModal: (pictures: File[]) => {
      setOpen(true)

      if (pictures.length > 0) picturesRef.current = pictures
    },
  }), [])

  return (
    <AddPicturesFromIncidentFormModalContext.Provider value={{ ...actions, isOpen, pictures: picturesRef.current}}>
      {children}
    </AddPicturesFromIncidentFormModalContext.Provider>
  )
}